import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Methodology from "./Methodology";
import NewEmployeeReport from "./NewEmployeeReport";

const NewEmployeeReportRoutes = () => {
    let { path } = useRouteMatch();
    return (
        <div>
            <Route exact path={path} component={NewEmployeeReport} />
            <Route path={`${path}/methodology`} component={Methodology}/>
        </div>
    );
}

export default NewEmployeeReportRoutes;